import { DocumentMapping } from "@/configuration/document-mappings/types";
import { Classification } from "@/src/models/constants/classifications";

export const FCC_MAPPINGS: Partial<Record<Classification, DocumentMapping>> = {
  [Classification.LAB_RESULTS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "LAB RESULTS",
    documentLabel: "{{ dateReceived YYYY-MM-DD }}, LAB RESULTS",
    folder: "External Records",
    folderMapping: "External Records",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "",
    classification: Classification.LAB_RESULTS,
    group: "fcc",
  },
  [Classification.MEDICAL_HISTORY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "MEDICAL SUMMARY",
    documentLabel: "{{ dateReceived YYYY-MM-DD }}, MEDICAL SUMMARY",
    folder: "External Records",
    folderMapping: "External Records",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "",
    classification: Classification.MEDICAL_HISTORY,
    group: "fcc",
  },
  [Classification.PROGRESS_NOTE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "PROGRESS NOTES",
    documentLabel: "{{ dateReceived YYYY-MM-DD }}, PROGRESS NOTE",
    folder: "External Records",
    folderMapping: "External Records",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "",
    classification: Classification.PROGRESS_NOTE,
    group: "fcc",
  },
  [Classification.INSURANCE_CARD]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "INSURANCE CARD",
    documentLabel: "{{ dateReceived YYYY-MM-DD }}, INSURANCE CARD",
    folder: "Insurance Card",
    folderMapping: "Insurance Card",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "",
    classification: Classification.INSURANCE_CARD,
    group: "fcc",
  },
  [Classification.REFERRAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "REFERRALS",
    documentLabel: "{{ dateReceived YYYY-MM-DD }}, REFERRAL",
    folder: "REFERRALS",
    folderMapping: "REFERRALS",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "",
    classification: Classification.REFERRAL,
    group: "fcc",
  },
  [Classification.REFERRAL_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "REFERRALS",
    documentLabel: "{{ dateReceived YYYY-MM-DD }}, REFERRAL",
    folder: "REFERRALS",
    folderMapping: "REFERRALS",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "",
    classification: Classification.REFERRAL_REQUEST,
    group: "fcc",
  },
} as const;
